import { State } from '../reducers/types'
import { Partner, PartnerPublicInfo } from 'src/interfaces/partner'

export const getPartnerPublicInfo = (state: State): PartnerPublicInfo | null =>
  state.partner.partnerPublic

export const getPartner = (state: State): Partner | null => state.partner.partner
